/* WeddingInvites.pk: "Complete order on WhatsApp"
   The design form sends a friendly, neatly grouped message to the team on WhatsApp.
   The website checkout button is removed. */
(function () {
  /* The design gallery's element name carries an ID that Shopify changes in every theme copy,
     so find it on the page instead of hard-coding it. */
  var TAG = (function () {
    var all = document.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) { if (/^wedding-templates-/i.test(all[i].tagName)) return all[i].tagName.toLowerCase(); }
    return 'wedding-templates-none';
  })();
  var SUFFIX = TAG.replace('wedding-templates-', '');
  var NUMBER = '447411543513';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || '').trim() : '';
  }
  function time12(v) {
    if (!v) return '';
    var p = v.split(':'), h = parseInt(p[0], 10), m = (p[1] || '00').slice(0, 2);
    if (isNaN(h)) return v;
    var ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + ':' + m + ' ' + ap;
  }
  function dateLong(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
    if (!m) return v || '';
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }
  /* ---------- Meta pixel tracking (via Shopify Customer Events custom pixel) ---------- */
  var __last = {};
  function track(name, p) {
    try {
      if (!p || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
      /* ignore duplicate fires of the same event for the same design within 1.5s (double-bound click listeners) */
      var key = name + '|' + p.id, now = Date.now();
      if (__last[key] && now - __last[key] < 1500) return;
      __last[key] = now;
      var cur = (Shopify.currency && Shopify.currency.active) || 'PKR';
      Shopify.analytics.publish(name, {
        content_name: p.name,
        content_ids: [String(p.id)],
        content_type: 'product',
        value: Number(p.priceRaw) / 100,   // Shopify prices are in minor units (3000.00 => 300000)
        currency: cur
      });
    } catch (e) {}
  }
  function productFromCard(card) {
    return { id: card.dataset.productId, name: card.dataset.productName, priceRaw: card.dataset.productPriceRaw };
  }

  function ref() { return 'WI-' + (1000 + Math.floor(Math.random() * 9000)); }

  function buildMessage(host) {
    var f = host.form, p = host.selectedProduct || {};
    var card = p.id ? host.querySelector('[data-product-id="' + p.id + '"]') : null;
    var link = card && card.querySelector('a[href*="/pages/"]');
    var preview = link ? location.origin + link.getAttribute('href') : (p.url ? location.origin + p.url : '');
    var date = dateLong(val(f, 'event_date')), time = time12(val(f, 'event_time'));
    var L = [];
    L.push('Hello! I’d love to book the *' + (p.name || 'wedding invitation') + '* invitation design. Here are our wedding details:');
    L.push('');
    L.push('*The couple*');
    L.push('Groom: ' + val(f, 'groom_name') + (val(f, 'groom_parents_name') ? ', son of ' + val(f, 'groom_parents_name') : ''));
    L.push('Bride: ' + val(f, 'bride_name') + (val(f, 'bride_parents_name') ? ', daughter of ' + val(f, 'bride_parents_name') : ''));
    L.push('');
    L.push('*Event*');
    if (val(f, 'event_name')) L.push(val(f, 'event_name'));
    if (date || time) L.push(date + (date && time ? ' at ' : '') + time);
    L.push('');
    L.push('*Venue*');
    if (val(f, 'venue_name')) L.push(val(f, 'venue_name'));
    if (val(f, 'venue_location')) L.push(val(f, 'venue_location'));
    if (val(f, 'venue_map_link')) L.push('Map: ' + val(f, 'venue_map_link'));
    L.push('');
    L.push('*Schedule*');
    if (val(f, 'guest_arrival_time')) L.push('Guest arrival: ' + time12(val(f, 'guest_arrival_time')));
    if (val(f, 'dining_time')) L.push('Dining: ' + time12(val(f, 'dining_time')));
    if (val(f, 'farewell_time')) L.push('Farewell: ' + time12(val(f, 'farewell_time')));
    if (val(f, 'invitation_message')) {
      L.push('');
      L.push('*Invitation message*');
      L.push('“' + val(f, 'invitation_message') + '”');
    }
    L.push('');
    L.push('*Please send the invitation link to:* ' + val(f, 'send_link_to'));
    L.push('');
    if (preview) L.push('Design preview: ' + preview);
    L.push('Ref: ' + ref());
    L.push('');
    L.push('Could you please share the payment details? Thank you!');
    return L.join('\n');
  }

  function showDone(host, url) {
    var dialog = host.modal && host.modal.firstElementChild;
    if (!dialog) return;
    var old = dialog.querySelector('.wi-order-done'); if (old) old.remove();
    var d = document.createElement('div');
    d.className = 'wi-order-done';
    d.innerHTML =
      '<div class="wi-order-done__in">' +
        '<span class="wi-order-done__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>' +
        '<h3>Almost done!</h3>' +
        '<p>WhatsApp has opened with your details filled in. Just tap <strong>Send</strong> and our team will reply with payment details and your invitation link.</p>' +
        '<a class="wi-order-done__wa" target="_blank" rel="noopener">WhatsApp didn’t open? Tap here</a>' +
        '<button type="button" class="wi-order-done__close">Back to designs</button>' +
      '</div>';
    d.querySelector('.wi-order-done__wa').href = url;
    d.querySelector('.wi-order-done__close').addEventListener('click', function () { d.remove(); dialog.style.overflow = ''; if (host.closeModal) host.closeModal(); });
    dialog.scrollTop = 0;
    dialog.style.overflow = 'hidden';
    dialog.appendChild(d);
  }

  function upgrade(host) {
    if (host.__wiOrder) return; host.__wiOrder = 1;
    if (host.cartBtn) host.cartBtn.style.setProperty('display', 'none', 'important');
    var wb = host.whatsappBtn;
    if (wb) {
      Array.prototype.slice.call(wb.childNodes).forEach(function (n) { if (n.nodeType === 3) n.remove(); });
      var s = document.createElement('span'); s.textContent = 'Complete order on WhatsApp'; wb.appendChild(s);
      wb.classList.add('wi-order-btn');
    }
    var footer = host.finalActions && host.finalActions.parentElement;
    if (footer && !footer.parentElement.querySelector('.wi-order-note')) {
      var note = document.createElement('p');
      note.className = 'wi-order-note';
      note.textContent = 'We’ll open WhatsApp with your details filled in. Just tap Send.';
      note.hidden = true;
      footer.insertAdjacentElement('afterend', note);
      host.__wiNote = note;
    }
  }

  function cardButtons(host) {
    var icon = host.whatsappBtn && host.whatsappBtn.querySelector('svg');
    host.querySelectorAll('[data-product-id]').forEach(function (card) {
      var row = card.querySelector('[class^="ai-wedding-templates-card-button-row-"]');
      if (!row || card.querySelector('.wi-card-wa')) return;
      var name = card.dataset.productName || 'wedding invitation';
      var link = card.querySelector('a[href*="/pages/"]');
      var msg = 'Hello! I’m interested in the *' + name + '* invitation design and would like to place an order.';
      if (link) msg += '\n\nDesign preview: ' + location.origin + link.getAttribute('href');
      msg += '\n\nCould you please guide me on the details you need and the payment process? Thank you!';
      var a = document.createElement('a');
      a.className = 'wi-card-wa';
      a.href = 'https://wa.me/' + NUMBER + '?text=' + encodeURIComponent(msg);
      a.target = '_blank'; a.rel = 'noopener';
      a.addEventListener('click', function () { track('weddinginvites:buy_now_click', productFromCard(card)); });
      if (icon) a.appendChild(icon.cloneNode(true));
      a.appendChild(document.createTextNode('Order on WhatsApp'));
      row.insertAdjacentElement('afterend', a);
    });
  }

  /* ---------- Live preview card (pilot: Ivory Bloom) ---------- */
  /* Per-design settings (background, colours, positions) live in wi-previews.js */
  (function () {
    var me = document.currentScript && document.currentScript.src;
    if (!me || window.WI_PREVIEWS) return;
    var sc = document.createElement('script');
    sc.src = me.replace(/wi-order\.js(\?.*)?$/, 'wi-previews.js') + '?d=' + new Date().toISOString().slice(0, 13);
    document.head.appendChild(sc);
  })();
  var TVARS = { ink: '--pv-ink', sub: '--pv-sub', acc: '--pv-acc', name: '--pv-name', nameFont: '--pv-name-font', glow: '--pv-glow', bg: '--pv-bg', card: '--pv-card', line: '--pv-line', cardInk: '--pv-card-ink', cardSub: '--pv-card-sub', cardAcc: '--pv-card-acc', overlay: '--pv-overlay', subCase: '--pv-sub-case' };
  var BISMILLAH = 'بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sample(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el && el.placeholder ? el.placeholder.replace(/^e\.g\.\s*/i, '') : '';
  }
  function fit(el, max, min) {
    var s = max; el.style.fontSize = s + 'px';
    while (s > min && el.scrollWidth > el.clientWidth + 1) { s -= 1; el.style.fontSize = s + 'px'; }
  }
  function loadAmiri() {
    if (document.getElementById('wi-amiri')) return;
    var l = document.createElement('link'); l.id = 'wi-amiri'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Amiri&family=Cinzel:wght@500;600&family=Cinzel+Decorative:wght@400;700&family=Tangerine:wght@400;700&display=swap';
    document.head.appendChild(l);
  }

  function buildPreview(host) {
    if (host.__wiPv) return host.__wiPv;
    var content = host.modal && host.modal.firstElementChild;
    if (!content) return null;
    loadAmiri();
    var aside = document.createElement('aside');
    aside.className = 'wi-pv';
    aside.innerHTML =
      '<button type="button" class="wi-pv__back">← Back to form</button>' +
      '<p class="wi-pv__label"><i></i>Your details: quick preview</p>' +
      '<div class="wi-pv__phone"><span class="wi-pv__ribbon">Preview</span><div class="wi-pv__screen">' +
        '<section class="wi-pv__hero" data-sec="hero"><div class="wi-pv__content">' +
          '<p class="wi-pv__bism">' + BISMILLAH + '</p>' +
          '<p class="wi-pv__name" data-k="groom"></p>' +
          '<p class="wi-pv__sub" data-k="gp"></p>' +
          '<p class="wi-pv__amp">&amp;</p>' +
          '<p class="wi-pv__name" data-k="bride"></p>' +
          '<p class="wi-pv__sub" data-k="bp"></p>' +
          '<span class="wi-pv__rule"></span>' +
          '<p class="wi-pv__event" data-k="event"></p>' +
          '<p class="wi-pv__date" data-k="date"></p>' +
          '<p class="wi-pv__time" data-k="time"></p>' +
          '<p class="wi-pv__venue" data-k="venue"></p>' +
        '</div><span class="wi-pv__scroll">Scroll ↓</span></section>' +
        '<section class="wi-pv__sec" data-sec="message">' +
          '<h5>Dear Friends &amp; Family</h5>' +
          '<p class="wi-pv__msg" data-k="msg"></p>' +
        '</section>' +
        '<section class="wi-pv__sec" data-sec="venue">' +
          '<h5>The Celebration</h5>' +
          '<p class="wi-pv__cap" data-k="event"></p>' +
          '<p class="wi-pv__big" data-k="date"></p>' +
          '<p class="wi-pv__line" data-k="time"></p>' +
          '<span class="wi-pv__rule"></span>' +
          '<p class="wi-pv__big" data-k="venue"></p>' +
          '<p class="wi-pv__line" data-k="loc"></p>' +
          '<span class="wi-pv__map" data-k="map">View on map</span>' +
        '</section>' +
        '<section class="wi-pv__sec" data-sec="schedule">' +
          '<h5>Schedule of Events</h5>' +
          '<div class="wi-pv__row"><span data-k="t1"></span><i></i><b>Guest arrival</b></div>' +
          '<div class="wi-pv__row"><span data-k="t2"></span><i></i><b>Dining</b></div>' +
          '<div class="wi-pv__row"><span data-k="t3"></span><i></i><b>Farewell</b></div>' +
        '</section>' +
        '<section class="wi-pv__sec wi-pv__end">' +
          '<h5>With love</h5>' +
          '<p class="wi-pv__big" data-k="names"></p>' +
        '</section>' +
      '</div></div>' +
      '<p class="wi-pv__note">This only shows how your details fit. Your real invitation opens with an animated envelope, an animated background, a scratch-to-reveal date and a live countdown.</p>' +
      '<a class="wi-pv__demo" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>See the full animated invitation</a>' +
      '<button type="button" class="wi-pv__done">Continue filling my details</button>';
    content.appendChild(aside);
    var strip = document.createElement('button');
    strip.type = 'button';
    strip.className = 'wi-pv-strip';
    strip.innerHTML = '<span class="wi-pv-strip__txt"><small>Quick preview</small><b data-k="names"></b></span><span class="wi-pv-strip__go">View ›</span>';
    host.form.parentElement.insertBefore(strip, host.form);
    function closeFull(fromPop) {
      if (!content.classList.contains('wi-pv-full')) return;
      content.classList.remove('wi-pv-full');
      if (!fromPop && history.state && history.state.wiPv) history.back();
    }
    strip.addEventListener('click', function () {
      content.classList.add('wi-pv-full');
      aside.scrollTop = 0;
      try { history.pushState({ wiPv: 1 }, ''); } catch (e) {}
      requestAnimationFrame(function () { renderPreview(host); });
    });
    aside.querySelector('.wi-pv__back').addEventListener('click', function () { closeFull(); });
    aside.querySelector('.wi-pv__done').addEventListener('click', function () { closeFull(); });
    window.addEventListener('popstate', function () { closeFull(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFull(); });
    var SEC = { event_date: 'venue', event_time: 'venue', venue_name: 'venue', venue_location: 'venue', venue_map_link: 'venue', guest_arrival_time: 'schedule', dining_time: 'schedule', farewell_time: 'schedule', invitation_message: 'message' };
    host.form.addEventListener('focusin', function (e) {
      var sec = SEC[e.target && e.target.name] || 'hero';
      var screen = aside.querySelector('.wi-pv__screen'), el = aside.querySelector('[data-sec="' + sec + '"]');
      if (screen && el) setTimeout(function () { screen.scrollTo({ top: sec === 'hero' ? 0 : el.offsetTop - 12, behavior: 'smooth' }); }, 220);
    });
    host.form.addEventListener('input', function () { renderPreview(host); });
    host.form.addEventListener('change', function () { renderPreview(host); });
    window.addEventListener('resize', function () { renderPreview(host); });
    host.__wiPv = { content: content, aside: aside, strip: strip };
    return host.__wiPv;
  }

  function renderPreview(host) {
    var pv = host.__wiPv; if (!pv || !pv.content.classList.contains('wi-pv-on')) return;
    var f = host.form;
    function put(k, value, fallback, prefix) {
      pv.aside.querySelectorAll('[data-k="' + k + '"]').forEach(function (el) {
        var real = !!value;
        el.textContent = real ? (prefix || '') + value : (fallback ? (prefix || '') + fallback : '');
        el.classList.toggle('is-sample', !real);
        el.style.display = el.textContent ? '' : 'none';
      });
    }
    var g = val(f, 'groom_name'), b = val(f, 'bride_name');
    put('groom', g, sample(f, 'groom_name') || 'Groom');
    put('bride', b, sample(f, 'bride_name') || 'Bride');
    put('gp', val(f, 'groom_parents_name'), sample(f, 'groom_parents_name'), 'Son of ');
    put('bp', val(f, 'bride_parents_name'), sample(f, 'bride_parents_name'), 'Daughter of ');
    var ev = f.querySelector('[name="event_name"]');
    put('event', ev && ev.value ? ev.value : '', 'Nikkah');
    var date = dateLong(val(f, 'event_date')), time = time12(val(f, 'event_time'));
    put('date', date, 'Saturday, 26 December 2026');
    put('time', time, '8:00 PM');
    put('venue', val(f, 'venue_name'), 'Majestic Banquet');
    put('loc', val(f, 'venue_location'), 'Shahrah-e-Faisal, Karachi');
    put('map', val(f, 'venue_map_link') ? 'View on map' : '', '');
    put('msg', val(f, 'invitation_message'), 'We are honored to welcome you to the wedding ceremony of ' + (g || 'Ali') + ' & ' + (b || 'Ayesha') + '. As they begin their journey together in faith and love, we thank you for being part of this blessed occasion ❤');
    put('t1', time12(val(f, 'guest_arrival_time')), '8:00 PM');
    put('t2', time12(val(f, 'dining_time')), '10:00 PM');
    put('t3', time12(val(f, 'farewell_time')), '11:00 PM');
    put('names', (g && b) ? g + ' & ' + b : '', (g || 'Ali') + ' & ' + (b || 'Ayesha'));
    var nmax = (pv.conf && pv.conf.nameMax) || 46;
    pv.aside.querySelectorAll('.wi-pv__hero .wi-pv__name').forEach(function (el) { el.style.lineHeight = ''; fit(el, nmax, 20); });
    var n = pv.strip.querySelector('[data-k="names"]');
    n.textContent = (g || sample(f, 'groom_name') || 'Groom') + ' & ' + (b || sample(f, 'bride_name') || 'Bride');
    fit(n, 24, 15);
  }

  function setupPreview(host) {
    var conf = (window.WI_PREVIEWS || {})[(host.selectedProduct || {}).name];
    var pv = conf ? buildPreview(host) : host.__wiPv;
    if (!pv) return;
    pv.content.classList.remove('wi-pv-full');
    pv.content.classList.toggle('wi-pv-on', !!conf);
    if (!conf) return;
    pv.conf = conf;
    var screen = pv.aside.querySelector('.wi-pv__screen'), t = conf.t || {};
    for (var k in TVARS) { if (t[k]) screen.style.setProperty(TVARS[k], t[k]); else screen.style.removeProperty(TVARS[k]); }
    screen.classList.toggle('wi-pv--panel', !!conf.panel);
    screen.style.setProperty('--pv-panel-top', conf.panel || '14%');
    screen.scrollTop = 0;
    pv.aside.querySelector('.wi-pv__hero').style.backgroundImage = 'url("' + conf.bg + '")';
    pv.aside.querySelector('.wi-pv__content').style.setProperty('padding-top', conf.panel ? '16px' : (conf.top || '21%'), 'important');
    var p = host.selectedProduct || {}, card = p.id ? host.querySelector('[data-product-id="' + p.id + '"]') : null;
    var link = card && card.querySelector('a[href*="/pages/"]'), demo = pv.aside.querySelector('.wi-pv__demo');
    if (link) { demo.href = link.getAttribute('href'); demo.style.display = ''; } else { demo.style.display = 'none'; }
    pv.strip.style.backgroundImage = 'linear-gradient(90deg, rgba(255,250,240,.94) 0%, rgba(255,250,240,.78) 55%, rgba(255,250,240,.35) 100%), url("' + conf.bg + '")';
    renderPreview(host);
    setTimeout(function () { renderPreview(host); }, 400);
  }

  var css = document.createElement('style');
  css.textContent =
    '#pricing .wi-order-btn{flex:1 1 auto!important;width:100%!important;gap:10px}' +
    '#pricing .ai-wedding-templates-final-actions-' + SUFFIX + '{flex:1 1 auto}' +
    '.wi-order-note{margin:0;padding:0 24px 18px;text-align:center;font:400 12.5px/1.5 var(--wi-sans,Jost,sans-serif);color:#6c6676}' +
    '.wi-order-done{position:absolute;inset:0;z-index:20;display:grid;place-items:center;padding:28px;background:var(--wi-paper,#fffcf6);border-radius:inherit;animation:wiOrderIn .35s ease}' +
    '@keyframes wiOrderIn{from{opacity:0}to{opacity:1}}' +
    '.wi-order-done__in{max-width:380px;text-align:center}' +
    '.wi-order-done__icon{display:grid;place-items:center;width:64px;height:64px;margin:0 auto 22px;border-radius:50%;background:#1f7a53;color:#fff}' +
    '.wi-order-done__icon svg{width:30px;height:30px}' +
    '.wi-order-done h3{margin:0 0 12px;font:600 34px/1.1 var(--wi-display,"Cormorant Garamond",serif);color:var(--wi-ink,#141a2e)}' +
    '.wi-order-done p{margin:0 0 24px;font:300 15.5px/1.65 var(--wi-sans,Jost,sans-serif);color:#4b4756}' +
    '.wi-order-done__wa{display:block;margin:0 0 14px;font:500 14px/1.4 var(--wi-sans,Jost,sans-serif);color:#1f7a53;text-decoration:underline;text-underline-offset:3px}' +
    '.wi-order-done__close{padding:13px 28px;border:1px solid rgba(156,122,65,.4);border-radius:999px;background:transparent;font:500 11.5px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.18em;text-transform:uppercase;color:var(--wi-ink,#141a2e);cursor:pointer}';
  css.textContent +=
    '#pricing .wi-card-wa{display:flex;align-items:center;justify-content:center;gap:9px;height:46px;margin-top:8px;border-radius:999px;background:#1f7a53;color:#fff;font:500 10.5px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.16em;text-transform:uppercase;text-decoration:none;transition:background .3s}' +
    '#pricing .wi-card-wa:hover{background:#18643f}' +
    '#pricing .wi-card-wa svg{width:16px;height:16px;flex:none}';
  css.textContent +=
    '.wi-pv,.wi-pv-strip{display:none}' +
    '.wi-pv-on .wi-pv-strip{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;box-sizing:border-box;margin:0 0 20px;padding:12px 14px;border:1px solid rgba(156,122,65,.35);border-radius:16px;background-size:cover;background-position:center 38%;cursor:pointer;text-align:left}' +
    '.wi-pv-strip__txt{display:flex;flex-direction:column;min-width:0;flex:1}' +
    '.wi-pv-strip__txt small{font:500 9.5px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.2em;text-transform:uppercase;color:#9c7a41;margin-bottom:6px;white-space:nowrap}' +
    '.wi-pv-strip__txt b{display:block;font:400 24px/1.15 "Pinyon Script",cursive;color:#2f2620;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.wi-pv-strip__go{flex:none;padding:9px 14px;border-radius:999px;background:#141a2e;color:#f8f3ea;font:500 10px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.16em;text-transform:uppercase}' +
    '.wi-pv__label{display:flex;align-items:center;justify-content:center;gap:8px;margin:0 0 14px;font:500 10px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.22em;text-transform:uppercase;color:#9c7a41}' +
    '.wi-pv__label i{width:7px;height:7px;border-radius:50%;background:#1f7a53;box-shadow:0 0 0 4px rgba(31,122,83,.15);animation:wiPvPulse 2s infinite}' +
    '@keyframes wiPvPulse{50%{box-shadow:0 0 0 7px rgba(31,122,83,0)}}' +
    '.wi-pv__phone{width:100%;max-width:290px;margin:0 auto;padding:9px;border-radius:38px;background:#141a2e;box-shadow:0 30px 60px -30px rgba(20,26,46,.6)}' +
    '.wi-pv__screen{--pv-ink:#2f2620;--pv-sub:#5b4632;--pv-acc:#9c7a41;--pv-name:#2f2620;--pv-name-font:"Pinyon Script",cursive;--pv-glow:0 0 12px rgba(255,250,240,.95),0 0 3px rgba(255,250,240,.9);--pv-bg:#f8f1e4;--pv-card:#fffaf0;--pv-line:rgba(184,146,79,.35);--pv-card-ink:#2f2620;--pv-card-sub:#5b4632;--pv-card-acc:#7d5f2c;--pv-overlay:none;--pv-sub-case:none;position:relative;aspect-ratio:9/17.5;border-radius:30px;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;scrollbar-width:none;background:var(--pv-bg)}' +
    '.wi-pv__screen::-webkit-scrollbar{display:none}' +
    '.wi-pv__hero{position:relative;height:100%;background:#f3ead9 center/cover no-repeat}' +
    '.wi-pv__hero::before{content:"";position:absolute;inset:0;background:var(--pv-overlay);pointer-events:none}' +
    '.wi-pv__scroll{position:absolute;left:0;right:0;bottom:10px;text-align:center;font:500 9px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.2em;text-transform:uppercase;color:#fff;text-shadow:0 1px 4px rgba(0,0,0,.5);animation:wiPvBob 2s ease-in-out infinite}' +
    '@keyframes wiPvBob{50%{transform:translateY(4px)}}' +
    '.wi-pv__sec{display:flex;flex-direction:column;align-items:center;margin:14px 12px;padding:22px 14px;border:1px solid var(--pv-line);border-radius:16px;background:var(--pv-card);text-align:center;color:var(--pv-card-ink)}' +
    '.wi-pv__sec p{margin:0}' +
    '.wi-pv__sec h5{margin:0 0 10px;font:400 25px/1.15 "Pinyon Script",cursive;color:var(--pv-card-acc)}' +
    '.wi-pv__msg{font:italic 500 13.5px/1.6 var(--wi-display,"Cormorant Garamond",serif);color:var(--pv-card-ink)}' +
    '.wi-pv__cap{font:500 10px/1.3 var(--wi-sans,Jost,sans-serif);letter-spacing:.24em;text-transform:uppercase;color:var(--pv-card-acc);margin-bottom:4px!important}' +
    '.wi-pv__big{font:600 15.5px/1.35 var(--wi-display,"Cormorant Garamond",serif)}' +
    '.wi-pv__line{font:500 13px/1.45 var(--wi-display,"Cormorant Garamond",serif);color:var(--pv-card-sub)}' +
    '.wi-pv__map{margin-top:10px;padding:7px 14px;border-radius:999px;background:var(--pv-card-acc);color:#fff;font:500 9.5px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.14em;text-transform:uppercase}' +
    '.wi-pv__row{display:grid;grid-template-columns:1fr 14px 1fr;align-items:center;gap:10px;width:100%;padding:7px 0}' +
    '.wi-pv__row span{text-align:right;font:600 14px/1.2 var(--wi-display,"Cormorant Garamond",serif)}' +
    '.wi-pv__row i{width:7px;height:7px;margin:auto;border-radius:50%;background:var(--pv-card-acc)}' +
    '.wi-pv__row b{text-align:left;font:500 13px/1.2 var(--wi-display,"Cormorant Garamond",serif);color:var(--pv-card-sub)}' +
    '.wi-pv__end{margin-bottom:18px}' +
    '.wi-pv__content{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;padding:16% 16px 0;text-align:center;color:var(--pv-ink)}' +
    '.wi-pv__content p{margin:0;text-shadow:var(--pv-glow)}' +
    '.wi-pv__bism{font:400 15px/1.6 Amiri,"Times New Roman",serif;margin-bottom:6px!important;color:var(--pv-sub)}' +
    '.wi-pv__name{width:100%;font:400 46px/1.15 var(--pv-name-font);color:var(--pv-name);white-space:nowrap;overflow:hidden;padding:0 4px .06em}' +
    '.wi-pv__sub{font:italic 500 12.5px/1.3 var(--wi-display,"Cormorant Garamond",serif);color:var(--pv-sub);text-transform:var(--pv-sub-case)}' +
    '.wi-pv__amp{font:400 28px/1.1 "Pinyon Script",cursive;color:var(--pv-acc);margin:2px 0!important}' +
    '.wi-pv__rule{display:block;width:46px;height:1px;margin:12px 0 10px;background:var(--pv-acc)}' +
    '.wi-pv__sec .wi-pv__rule{background:var(--pv-card-acc)}' +
    '.wi-pv__event{font:500 11px/1.3 var(--wi-sans,Jost,sans-serif);letter-spacing:.24em;text-transform:uppercase;color:var(--pv-acc)}' +
    '.wi-pv__date{margin-top:5px!important;font:500 14px/1.35 var(--wi-display,"Cormorant Garamond",serif)}' +
    '.wi-pv__time{font:500 13px/1.35 var(--wi-display,"Cormorant Garamond",serif);letter-spacing:.06em}' +
    '.wi-pv__venue{font:italic 500 13.5px/1.35 var(--wi-display,"Cormorant Garamond",serif);color:var(--pv-sub)}' +
    '.wi-pv--panel .wi-pv__content{inset:var(--pv-panel-top) 12px auto;padding:16px 10px 14px!important;border-radius:20px;background:rgba(252,250,245,.8);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border:1px solid rgba(196,161,101,.35);box-shadow:0 10px 30px rgba(20,26,46,.12)}' +
    '.wi-pv--panel .wi-pv__name{font-size:40px}' +
    '.wi-pv .is-sample{opacity:.45}' +
    '.wi-pv__note{max-width:280px;margin:14px auto 0;text-align:center;font:400 11.5px/1.5 var(--wi-sans,Jost,sans-serif);color:#8a8494}' +
    '.wi-pv__back,.wi-pv__done{display:none}' +
    '.wi-pv__phone{position:relative}' +
    '.wi-pv__ribbon{position:absolute;top:22px;right:22px;z-index:3;padding:5px 10px;border-radius:999px;background:rgba(20,26,46,.82);color:#f3e6c4;font:600 9px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.22em;text-transform:uppercase;pointer-events:none;box-shadow:0 4px 12px rgba(0,0,0,.18)}' +
    '.wi-pv__demo{display:flex;align-items:center;justify-content:center;gap:9px;max-width:290px;margin:14px auto 0;padding:13px 16px;border-radius:999px;background:#141a2e;color:#f8f3ea;font:500 10.5px/1.2 var(--wi-sans,Jost,sans-serif);letter-spacing:.14em;text-transform:uppercase;text-decoration:none;transition:background .3s}' +
    '.wi-pv__demo:hover{background:#2a3254}' +
    '.wi-pv__demo svg{width:14px;height:14px;flex:none;color:#c4a165}' +
    '.wi-pv-full .wi-pv__demo{background:#c4a165;color:#141a2e}' +
    '.wi-pv-full .wi-pv__demo svg{color:#141a2e}' +
    '.wi-pv-full .wi-pv{display:flex;flex-direction:column;justify-content:flex-start;position:fixed;inset:0;z-index:40;padding:78px 20px calc(28px + env(safe-area-inset-bottom));background:rgba(20,26,46,.98);overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}' +
    '.wi-pv-full .wi-pv__label,.wi-pv-full .wi-pv__note{color:#e4cf9f}' +
    '.wi-pv-full .wi-pv__phone{max-width:300px;background:#0c1020}' +
    '.wi-pv-full .wi-pv__back{display:flex;align-items:center;justify-content:center;gap:8px;position:fixed;top:14px;left:50%;transform:translateX(-50%);z-index:45;margin:0;padding:13px 24px;border:1px solid rgba(228,207,159,.55);border-radius:999px;background:#141a2e;box-shadow:0 10px 30px -8px rgba(0,0,0,.6);color:#f8f3ea;font:500 11px/1 var(--wi-sans,Jost,sans-serif);letter-spacing:.16em;text-transform:uppercase;white-space:nowrap;cursor:pointer}' +
    '.wi-pv-full .wi-pv__done{display:block;width:100%;max-width:290px;margin:12px auto 0;padding:14px 16px;border:1px solid rgba(228,207,159,.55);border-radius:999px;background:transparent;color:#f8f3ea;font:500 10.5px/1.2 var(--wi-sans,Jost,sans-serif);letter-spacing:.14em;text-transform:uppercase;cursor:pointer}' +
    '@media (min-width:900px){' +
      '.wi-pv-on{max-width:1000px!important;display:grid!important;grid-template-columns:minmax(0,1fr) 340px;align-items:start}' +
      '.wi-pv-on>*{grid-column:1}' +
      '.wi-pv-on>[class*="modal-header"]{grid-column:1/-1}' +
      '.wi-pv-on .wi-pv{display:block;grid-column:2;grid-row:2/span 4;position:sticky;top:0;padding:28px 28px 28px 8px}' +
      '.wi-pv-on .wi-pv-strip{display:none}' +
      '.wi-pv-on.wi-pv-full .wi-pv{position:sticky;inset:auto;background:none;padding:28px 28px 28px 8px}' +
      '.wi-pv-on .wi-pv__back,.wi-pv-on .wi-pv__done{display:none!important}' +
    '}';
  document.head.appendChild(css);

  customElements.whenDefined(TAG).then(function () {
    var C = customElements.get(TAG), P = C.prototype;
    var go = P.goToStep, open = P.openModal;
    P.goToStep = function (step) {
      var r = go.apply(this, arguments);
      if (this.__wiNote) this.__wiNote.hidden = this.currentStep !== 3;
      return r;
    };
    if (open) P.openModal = function () {
      var dialog = this.modal && this.modal.firstElementChild;
      var old = dialog && dialog.querySelector('.wi-order-done'); if (old) old.remove();
      if (dialog) dialog.style.overflow = '';
      this.__wiLeadSent = false;
      var r = open.apply(this, arguments);
      setupPreview(this);
      track('weddinginvites:buy_now_click', this.selectedProduct);
      return r;
    };
    P.handleWhatsAppOrder = function () {
      if (this.isSubmitting) return;
      if (this.validateForm && !this.validateForm()) return;
      var url = 'https://wa.me/' + NUMBER + '?text=' + encodeURIComponent(buildMessage(this));
      if (!this.__wiLeadSent) { this.__wiLeadSent = true; track('weddinginvites:whatsapp_lead', this.selectedProduct); }
      window.open(url, '_blank', 'noopener,noreferrer');
      showDone(this, url);
    };
    P.handleCartOrder = function () { this.handleWhatsAppOrder(); };
    document.querySelectorAll(TAG).forEach(function (h) {
      upgrade(h);
      cardButtons(h);
      if (h.__wiNote) h.__wiNote.hidden = h.currentStep !== 3;
    });
  });
})();